import { useState } from 'react';
import Drawer from '@base/Drawer/Drawer';
import FirstSection from './FirstSection';
import SecondSection from './SecondSection';
import ThirdSection from './ThirdSection';
import FourthSection from './FourthSection';
import Login from './Login';

const ClassroomHomepage = () => {
  const [isModalShown, showModal] = useState(false);
  const [modalType, setModalType] = useState('signup');
  const openAccountDrawer = (type = 'signup') => {
    setModalType(type);
    showModal(true);
  };

  const closeModal = () => {
    showModal(false);
  };

  const renderModal = () => {
    return (
      <Drawer login drawerState={isModalShown} onClose={closeModal}>
        <Login type={modalType} />
      </Drawer>
    );
  };

  return (
    <div style={{ background: 'var(--color-base-0)', paddingTop: '120px' }}>
      <FirstSection openAccountDrawer={openAccountDrawer} />
      <div style={{ width: '1136px', margin: 'auto auto -36px auto' }}>
        <SecondSection />
        <ThirdSection openAccountDrawer={openAccountDrawer} />
        <FourthSection />
      </div>
      {renderModal()}
    </div>
  );
};

export default ClassroomHomepage;
